import { render, staticRenderFns } from "./LeaveRecordNew.vue?vue&type=template&id=65fc414e"
import script from "./LeaveRecordNew.vue?vue&type=script&lang=js"
export * from "./LeaveRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports